import * as React from "react";

function SvgBack(props) {
  return (
    <svg width={16} height={16} {...props}>
      <path
        data-name="Path 10"
        d="M8 16l1.455-1.455-5.506-5.506H16V6.961H3.948l5.507-5.506L8 0 0 8z"
        fill="#f7a51b"
      />
    </svg>
  );
}

export default SvgBack;
